import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Button as ButtonS } from "semantic-ui-react";
import { Button } from 'reactstrap';

export const ViewDocumentPDF = () => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
    const [numPage, setnumPage] = useState(null);
    const [pageNumber] = useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setnumPage(numPages);
    }

    return (
        <div>
            <div className='w-100 bg-secondary py-3 px-5 mb-3 text-right'>
                <ButtonS color="blues">Download</ButtonS>
            </div>
            <div className="d-flex justify-content-center">
                {/* <p>Page {pageNumber} of {numPage}</p> */}
                <Document
                    file={require("./invoice.pdf")}
                    // file={{
                    //     // url:'https://etanee-images.s3-ap-southeast-1.amazonaws.com/temp/invoice_O20033218.pdf',
                    //     // httpHeaders: { },
                    //     // withCredentials: true
                    // }}
                    options={{
                        cMapUrl: 'cmaps/',
                        cMapPacked: true,
                    }}
                    onLoadError={console.error}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    <Page pageNumber={pageNumber} />
                </Document>
            </div>
        </div>
    )
}